import { InjectionToken } from '@angular/core'
import {
  initialize,
  LDClient,
  LDOptions,
  LDUser,
} from 'launchdarkly-js-client-sdk'

export const FEATURE_FLAG_CONFIG = new InjectionToken('FEATURE_FLAG_CONFIG')
export const FEATURE_FLAG_FACTORY = new InjectionToken<LDClient | null>(
  'FEATURE_FLAG_FACTORY'
)

export const launchDarklyFactory = (
  config: FeatureFlagConfiguration
): LDClient => initialize(config.key, config.defaultUser, config.options)

export interface FeatureFlagConfiguration {
  key: string
  defaultUser: LDUser
  options?: LDOptions
}

export interface FeatureFlagAsyncConfiguration {
  useFactory: (...args: any[]) => Promise<FeatureFlagConfiguration>
  deps?: any[]
}
